// extracted by mini-css-extract-plugin
module.exports = {"articlesList":"_63aa771353d45cee6823e2362cd12aa5-less","articlesItem":"_86fce369a6a9bee1fd96a1e816329b47-less"};